import React from "react";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import IOSSwitch from "../IOSSwitch";
import { usePaymentTheme } from "../../respayment/hooks/usePaymentTheme";
import { useUser } from "src/shared/context/UserContext";

interface OrderTypeToggleProps {
  isDelivery: boolean;
  setIsDelivery: (value: boolean) => void;
  orderId?: string;
}

const OrderTypeToggle: React.FC<OrderTypeToggleProps> = ({
  isDelivery,
  setIsDelivery,
  orderId,
}) => {
  const { themeTextColor, getBgClass, themeBorderColor } = usePaymentTheme();
  const { userConfigration } = useUser();

  const toBoolean = (value: any) => value === true || value === "true";
  const deliveryFeeEnabled = toBoolean(userConfigration?.deliveryFeeEnabled);

  const inactiveClass = "border-gray-200 bg-gray-100 text-gray-500";
  const activeClass = `${themeBorderColor} bg-white ${themeTextColor} shadow`;

  return (
    <div className="flex flex-col gap-3 w-full">

      {/* Top Row */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">

        {/* Toggle Section */}
        <div className="flex items-center justify-between sm:justify-start gap-2 w-full sm:w-auto">

          {/* Table */}
          <button
            className={`flex items-center gap-2 px-2 py-1.5 rounded-lg border transition-all duration-200 text-xs sm:text-sm
              ${!isDelivery ? activeClass : inactiveClass}`}
            onClick={() => setIsDelivery(false)}
          >
            <TableRestaurantIcon className="text-base sm:text-lg" />
            Table
          </button>

          {/* Switch */}
          {deliveryFeeEnabled && (
            <div className="flex items-center">
              <IOSSwitch
                checked={isDelivery}
                onChange={(e: { target: { checked: boolean } }) =>
                  setIsDelivery(e.target.checked)
                }
              />
            </div>
          )}

          {/* Delivery */}
          {deliveryFeeEnabled && (
            <button
              className={`flex items-center gap-2 px-2 py-1.5 rounded-lg border transition-all duration-200 text-xs sm:text-sm
                ${isDelivery ? activeClass : inactiveClass}`}
              onClick={() => setIsDelivery(true)}
            >
              <DeliveryDiningIcon className="text-base sm:text-lg" />
              Delivery
            </button>
          )}
        </div>

        {/* Order Badge */}
        <div className="flex items-center gap-2 px-2.5 py-1 bg-gray-50 rounded-md border w-fit">
  <LocalMallIcon className="text-gray-400 text-base" />
  <div className="flex flex-col leading-tight">
    <span className="text-[9px] text-gray-500">Order No</span>
    <span className={`text-xs font-semibold ${themeTextColor}`}>
      {!orderId ? "New Order" : `#${orderId}`}
    </span>
  </div>
</div>

      </div>
    </div>
  );
};

export default OrderTypeToggle;
